import { useMemo } from "react";

interface LogoProps {
    style?: "white" | "blue" | "black";
}

export const Logo = ({ style }: LogoProps) => {
    const url = useMemo(() => {
        if (style === "white") return "/electify_logo_white.svg";
        if (style === "black") return "/electify_logo_black.svg";
        if (style === "blue") return "/electify_logo_blue.svg";
        return "/electify_logo_white.svg"
    }, [style]);

    return <img src={url} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", width: 140 }} />
}